export default class Resource {
    static import(resources) {
        const promises = [];
        resources.forEach((resource) => {
            promises.push(new Promise((resolve, reject) => {
                if (Resource.loadedResources[resource.url]) {
                    resolve(Resource.loadedResources[resource.url]);
                }
                else {
                    const el = Resource.createElement(resource);
                    el.onload = (res) => {
                        resolve(res);
                        el.onload = null;
                    };
                    document.head.appendChild(el);
                }
            }));
        });
        return Promise.all(promises);
    }
    static createElement(resource) {
        let el;
        if (resource.type === 'script') {
            el = document.createElement('script');
            el.src = resource.url;
            el.type = 'text/javascript';
        }
        else {
            el = document.createElement('link');
            el.type = 'text/css';
            el.rel = 'stylesheet';
            el.href = resource.url;
        }
        return el;
    }
}
Resource.loadedResources = {};
